export enum TextInputType {
  TEXT = 'text',
  EMAIL = 'email',
  PASSWORD = 'password',
  PHONE = 'tel',
  NUMBER = 'number',
  DATE = 'date'
}

export enum TextInputWidth {
  FULL = '100',
  THREE_QUARTER = '75',
  HALF = '50'
}

export interface BaseInputProps {
  value: string | number | readonly string[] | undefined;
  type: TextInputType;
  label: string;
  placeholder?: string;
  error?: string | null;
  disabled?: boolean;
  required?: boolean;
  inputMode?:
    | 'text'
    | 'none'
    | 'email'
    | 'search'
    | 'tel'
    | 'url'
    | 'numeric'
    | 'decimal'
    | undefined;
  pattern?: string;
  width?: TextInputWidth;
  maxLength?: number;
}
